// src/api/weatherService.js
//
// Prognoza meteo pe ore de la Open-Meteo (gratuit, fără cheie, permite
// cereri din browser). Se trimit doar coordonatele sectorului, nimic despre
// utilizator, și fără tokenul aplicației (nu trece prin apiClientService).
// Răspunsul ține 30 de minute în memorie.

const BASE = "https://api.open-meteo.com/v1/forecast";
const TTL_MS = 30 * 60 * 1000;
const HOURLY = [
   "temperature_2m",
   "apparent_temperature",
   "precipitation_probability",
   "precipitation",
   "weather_code",
   "wind_speed_10m",
   "visibility",
   "is_day",
].join(",");

const cache = new Map();

export async function getHourlyForecast({ latitude, longitude, days = 2 }) {
   const key = `${latitude.toFixed(3)},${longitude.toFixed(3)},${days}`;
   const hit = cache.get(key);
   if (hit && Date.now() - hit.at < TTL_MS) return hit.data;

   const params = new URLSearchParams({
      latitude: String(latitude),
      longitude: String(longitude),
      hourly: HOURLY,
      timezone: "Europe/Chisinau",
      forecast_days: String(days),
      wind_speed_unit: "kmh",
   });
   const res = await fetch(`${BASE}?${params.toString()}`, { credentials: "omit" });
   if (!res.ok) throw new Error(`Open-Meteo ${res.status}`);
   const data = await res.json();
   cache.set(key, { at: Date.now(), data });
   return data;
}
